import React from 'react'
import './modal-content.scss'

export default (props) => {
  return (
    <div className="cs-modal">
      <div className="cs-modal-dialog">
        <div className="cs-modal-content">
          <header className="cs-modal-header">
            <h1 className='cs-modal-title'>{props.title}</h1>
            <button className='close' onClick={props.closeModal}>x</button>
          </header>
          <div className="cs-modal-body">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/modal-panels/modal-content.js